//  default product page variants click data update js
function shadeSeletedImgShow(shade_seleted, optionNumber, list) {
  const specificSwatchsImgs = document.querySelectorAll(
    `.${list} [data-swatchs-name="${shade_seleted}"]`
  );
  specificSwatchsImgs.forEach((sis) => (sis.style.display = "block"));

  let otherShade = [];
  const allOption1Shade = document.querySelectorAll(
    `.product-form__input.${optionNumber} label`
  );
  allOption1Shade.forEach((cc) => {
    otherShade.push(cc.getAttribute("data-swatch-name"));
  });

  const updatedShade = otherShade.filter((shade) => shade != shade_seleted);
  updatedShade.forEach((cc) => {
    const specificSwatchsImgs = document.querySelectorAll(
      `.${list} [data-swatchs-name="${cc}"]`
    );
    specificSwatchsImgs.forEach((sis) => (sis.style.display = "none"));
  });
}

//   options click and call img show and hide function based on swatch
function shadeDefaultOptionsClick(optionNumber) {
  const options_shade = document.querySelector(`.${optionNumber}`);
  if (!options_shade) return;
  options_shade.addEventListener("click", function (e) {
    let curr_sel = e.target.closest(".swatch-labels");

    if (curr_sel) {
      let currenSelected = curr_sel.getAttribute("data-swatch-name");
      //              options_shade.querySelector('.product-variants-hover-option').innerHTML = currenSelected;
      shadeSeletedImgShow(currenSelected, optionNumber, "thumbnail-list");
      //              shadeSeletedImgShow(currenSelected,optionNumber,'mobile__slide__data');
      shadeSeletedImgShow(currenSelected, optionNumber, "product__media-list");
      // if(window.screen.width < 768 ){
      //    window.scrollTo({
      //       top: 0,
      //       behavior: "smooth"
      //   });
      // }
    }
  });
}

// call function options click function
const p_options1 = document.querySelector(".product-form__input.options1");
const p_options2 = document.querySelector(".product-form__input.options2");
const p_options3 = document.querySelector(".product-form__input.options3");

if (p_options1) {
  shadeDefaultOptionsClick("options1");
}
if (p_options2) {
  shadeDefaultOptionsClick("options2");
}
if (p_options3) {
  shadeDefaultOptionsClick("options3");
}
